function About(){
    return(
        <div>
            <div className="about">
        <div className="container">
            <div className="row">
                <div className="col-md-12">
                    <h4>"An intuitive solution to a common<br></br> problem that we all face, wrapped up <br></br> in a single app!"</h4>
                    <img src="img/tnw-logo.svg" alt="" className="img-fluid"></img>
                </div>
            </div>
        </div>
    </div>
        </div>
    )
}

export default About ;